import React from "react";
import TextField from "@mui/material/TextField";

import Input from "../../../components/form/Input";

export default function CreatedByEmail({ email, user: inventoryRequestUser }) {
  return (
    email ? (
      <Input name="email" label="Created by Email" />
    ) : (
      <TextField
        disabled
        label="Created By"
        value={inventoryRequestUser?.email || ""}
        fullWidth
        size="small"
        variant="outlined"
      />
    )
  );
}
